
import { defineComponent } from 'vue'
import { trackLeadLink } from '@/utils/metaPixel'

export default defineComponent({
  name: 'Footer',
  methods: {
    onShopLeadClick(event: MouseEvent, url: string, contentName: string) {
      trackLeadLink(event, url, {
        contentName,
        contentCategory: 'mt_shop_footer_link',
      })
    },
  },
  computed: {
    activeService(): string {
      const path = this.$route.path
      if (path.includes('/services/mt-clickbait')) return 'clickbait'
      if (path.includes('/services/mt-agency')) return 'agency'
      if (path.includes('/services/mt-shop')) return 'shop'
      return 'default'
    },
    activeColor(): string {
      switch (this.activeService) {
        case 'clickbait': return '#F6FF00'
        case 'agency': return '#01AAFC'
        case 'shop': return '#F50108'
        default: return '#FFFFFF'
      }
    },
  },
})
